import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css"; // using same styling for all legal pages

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="glass-background"></div>

      {/* NAV */}
      <nav className="legal-nav">
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/icons/logo-512.png" className="nav-logo" alt="GrammAA" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      {/* CONTENT */}
      <div className="legal-content glass-panel fade-in">
        <h1>Contact Us</h1>
        <p className="updated-date">Last updated: {new Date().getFullYear()}</p>

        <p>
          We're here to help! If you have any questions, concerns, or need support,
          feel free to reach out to our team using the contact details below.
        </p>

        <h2>📩 Email Support</h2>
        <p>
          For general inquiries, technical support, or account-related questions:
          <br />
          <strong>support@aiwebaa.com</strong>
        </p>

        <h2>💼 Business & Partnership</h2>
        <p>
          For business proposals, collaborations, or partnership requests:
          <br />
          <strong>support@aiwebaa.com</strong>
        </p>

        <h2>🧾 Billing & Payments</h2>
        <p>
          For payment issues, refund requests, or billing concerns:
          <br />
          <strong>support@aiwebaa.com</strong>
        </p>

        <h2>🌍 Office Address</h2>
        <p>
          <strong>aiwebAA — GrammAA Division</strong>
          <br />
          Bengaluru, Karnataka, India  
          <br />
          (Note: This is a virtual business address used for corporate operations)
        </p>

        <h2>⏱ Support Availability</h2>
        <p>
          Our support team is available:
          <br />
          <strong>Monday to Saturday — 10:00 AM to 7:00 PM (IST)</strong>
        </p>

        <h2>📨 Response Time</h2>
        <p>
          We typically reply within:
          <br />
          <strong>6–24 hours</strong> (depending on the queue)
        </p>

        <br />
        <p>Thank you for choosing GrammAA. We're always happy to assist you.</p>
      </div>
    </div>
  );
};

export default Contact;
